import { Button, Avatar, Dropdown } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useLogout } from '../auth/useAuth';
import type { Me } from '../api/client';

/** 後台右上角使用者選單：角色、我的帳號、登出。 */
export default function HeaderUserMenu({ me }: { me: Me }) {
  const navigate = useNavigate();
  const logout = useLogout();
  const name = me.displayName || me.email || '使用者';

  return (
    <Dropdown
      menu={{
        items: [
          { key: 'role', label: `角色：${me.roles.join(', ') || '無'}`, disabled: true },
          { type: 'divider' },
          { key: 'account', icon: <UserOutlined />, label: '我的帳號', onClick: () => navigate('/account') },
          { key: 'logout', icon: <LogoutOutlined />, label: '登出', onClick: () => logout.mutate() },
        ],
      }}
    >
      <Button type="text" className="flex items-center gap-2">
        <Avatar size="small" className="!bg-[#dd7900]">
          {name[0]?.toUpperCase() ?? 'U'}
        </Avatar>
        <span className="text-sm text-gray-600">{name}</span>
      </Button>
    </Dropdown>
  );
}
